import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const getAllAppAction = createAsyncThunk(
    'get-all-app',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/getAllApp`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const allAllAppSlice = createSlice({
    name: 'get-all-app',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalPages = action?.payload?.totalPages
            })
            builder.addCase(getAllAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAllAppReducer = allAllAppSlice.reducer